<ng-content select="[collapsibleHeader]"></ng-content>

<div [ngClass]="{ 'no-height': !_opened }">
    <ng-content select="[collapsibleBody]"></ng-content>
</div>
